import { memo } from "react";
import { Navbar as NavbarComponent, NavbarMenu, useBuildMenu } from "@tecorien/mimic";
import { Help } from "./Help";
import { Logo } from "./Logo";
import { ProfileBlock } from "./ProfileBlock";

import styles from "./style.module.scss";

export type NavbarProps = {
  className?: string
  hideMenu?: boolean
  hideProfile?: boolean
  rootLink?: string
}

export const Navbar = memo<NavbarProps>(({ className, hideMenu, hideProfile, rootLink }) => {
  const menuList = useBuildMenu();
  return (
    <NavbarComponent className={className}>
      <Logo link={rootLink} />
      {
        !hideMenu &&
        <div className={styles.content}>
          <NavbarMenu menuList={menuList} />
        </div>
      }
      <div className={styles.rightBlock}>
        <Help />
        {
          !hideProfile && <ProfileBlock />
        }
      </div>
    </NavbarComponent>
  );
});

export default Navbar;